import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'

import { SUMMARY_TYPES } from '../constant'

import useProject from '../../../../hooks/useProject'

// customer
const DEFAULT_CUSTOMER_FORM_INFO = {
	projectName: 'Lookups',
	formName: 'Customers',
}

// job
const DEFAULT_JOB_FORM_INFO = {
	projectName: 'Lookups',
	formName: 'Job Summary',
}

const DEFAULT_NEW_JOB_FORM_INFO = {
	projectName: 'Lookups',
	formName: 'Jobs',
}

const DEFAULT_JOB_HISTORY_FORM_INFO = {
	projectName: 'Main Project',
	formName: 'Job History',
}

const DEFAULT_EDIT_JOB_FORM_INFO = {
	projectName: 'Main Project',
	formName: 'Edit Job',
}

// task
const DEFAULT_TASK_FORM_INFO = {
	projectName: 'Lookups',
	formName: 'Tasks Summary',
}

const DEFAULT_NEW_TASK_FORM_INFO = {
	projectName: 'Main Project',
	formName: 'Add Tasks',
}

function buildProjectFormInfoByDefault(projects, defaultInfo) {
	if (isEmpty(projects) || isEmpty(defaultInfo)) return {}
	const projectFormInfo = projects.reduce((acc, proj) => {
		if (proj.name === defaultInfo.projectName) {
			const form = proj.forms?.find((form) => form.name === defaultInfo.formName)

			return {
				projectKey: proj.key ?? '',
				projectName: proj.name ?? '',
				formName: form?.name ?? '',
				formKey: form?.key ?? '',
			}
		}

		return acc
	}, {})
	return projectFormInfo
}

export function useSummaryDefaultProjectFormInfo(props) {
	const { summaryType } = props
	const { projectLoading, projects } = useProject({ enabled: true })

	const [selectedNewJobForm, setSelectedNewJobForm] = useState(null)
	const [selectedJobForm, setSelectedJobForm] = useState(null)
	const [selectedEditJobForm, setSelectedEditJobForm] = useState(null)

	const [selectedCustomerForm, setSelectedCustomerForm] = useState(null)

	const [selectedJobActivityForm, setSelectedJobActivityForm] = useState(null)
	const [selectedNewTaskForm, setSelectedNewTaskForm] = useState(null)

	const [selectedJobHistoryForm, setSelectedJobHistoryForm] = useState(null)

	useEffect(() => {
		if (projectLoading || isEmpty(projects)) return

		const customerForm = buildProjectFormInfoByDefault(projects, DEFAULT_CUSTOMER_FORM_INFO)
		setSelectedCustomerForm(customerForm)
		switch (summaryType) {
			case SUMMARY_TYPES.JOB:
				const newJobForm = buildProjectFormInfoByDefault(projects, DEFAULT_NEW_JOB_FORM_INFO)
				setSelectedNewJobForm(newJobForm)

				const jobForm = buildProjectFormInfoByDefault(projects, DEFAULT_JOB_FORM_INFO)
				setSelectedJobForm(jobForm)

				const editJobForm = buildProjectFormInfoByDefault(projects, DEFAULT_EDIT_JOB_FORM_INFO)
				setSelectedEditJobForm(editJobForm)

				const addTaskForm = buildProjectFormInfoByDefault(projects, DEFAULT_NEW_TASK_FORM_INFO)
				setSelectedNewTaskForm(addTaskForm)

				const jobHistoryForm = buildProjectFormInfoByDefault(
					projects,
					DEFAULT_JOB_HISTORY_FORM_INFO
				)
				setSelectedJobHistoryForm(jobHistoryForm)
				break
			case SUMMARY_TYPES.TASK:
				const selectedSummaryTaskForm = buildProjectFormInfoByDefault(
					projects,
					DEFAULT_TASK_FORM_INFO
				)
				setSelectedJobActivityForm(selectedSummaryTaskForm)
				const selectedNewSummaryTaskForm = buildProjectFormInfoByDefault(
					projects,
					DEFAULT_NEW_TASK_FORM_INFO
				)
				setSelectedNewTaskForm(selectedNewSummaryTaskForm)
				break
			case SUMMARY_TYPES.EMPLOYEE:
				const employeeAddTaskForm = buildProjectFormInfoByDefault(
					projects,
					DEFAULT_NEW_TASK_FORM_INFO
				)
				setSelectedNewTaskForm(employeeAddTaskForm)
				break
			default:
				break
		}
	}, [projects, projectLoading])

	return {
		projectLoading: projectLoading,
		selectedCustomerForm,
		selectedNewJobForm,
		selectedJobForm,
		selectedEditJobForm,
		selectedJobActivityForm,
		selectedNewTaskForm,
		selectedJobHistoryForm,
	}
}
